// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Monad_State_Class = require("../Control.Monad.State.Class/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Unit = require("../Data.Unit/index.js");
var Effect_Class = require("../Effect.Class/index.js");
var Effect_Unsafe = require("../Effect.Unsafe/index.js");
var Halogen_Component = require("../Halogen.Component/index.js");
var Halogen_HTML_Elements = require("../Halogen.HTML.Elements/index.js");
var Halogen_HTML_Events = require("../Halogen.HTML.Events/index.js");
var Halogen_HTML_Properties = require("../Halogen.HTML.Properties/index.js");
var Halogen_Query_EventSource = require("../Halogen.Query.EventSource/index.js");
var Halogen_Query_HalogenM = require("../Halogen.Query.HalogenM/index.js");
var Lunarbox_Component_Utils = require("../Lunarbox.Component.Utils/index.js");
var Lunarbox_Foreign_Render = require("../Lunarbox.Foreign.Render/index.js");
var Web_HTML = require("../Web.HTML/index.js");
var Web_HTML_Window = require("../Web.HTML.Window/index.js");
var LoadScene = (function () {
    function LoadScene(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    LoadScene.create = function (value0) {
        return function (value1) {
            return new LoadScene(value0, value1);
        };
    };
    return LoadScene;
})();
var HandleResize = (function () {
    function HandleResize(value0) {
        this.value0 = value0;
    };
    HandleResize.create = function (value0) {
        return new HandleResize(value0);
    };
    return HandleResize;
})();
var Rerender = (function () {
    function Rerender(value0) {
        this.value0 = value0;
    };
    Rerender.create = function (value0) {
        return new Rerender(value0);
    };
    return Rerender;
})();
var BubbleForeignAction = (function () {
    function BubbleForeignAction(value0) {
        this.value0 = value0;
    };
    BubbleForeignAction.create = function (value0) {
        return new BubbleForeignAction(value0);
    };
    return BubbleForeignAction;
})();
var Init = (function () {
    function Init() {

    };
    Init.value = new Init();
    return Init;
})();
var Render = (function () {
    function Render() {

    };
    Render.value = new Render();
    return Render;
})();
var ResizeCanvas = (function () {
    function ResizeCanvas() {

    };
    ResizeCanvas.value = new ResizeCanvas();
    return ResizeCanvas;
})();
var HandleEvent = (function () {
    function HandleEvent(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    HandleEvent.create = function (value0) {
        return function (value1) {
            return new HandleEvent(value0, value1);
        };
    };
    return HandleEvent;
})();
var HandleForeignAction = (function () {
    function HandleForeignAction(value0) {
        this.value0 = value0;
    };
    HandleForeignAction.create = function (value0) {
        return new HandleForeignAction(value0);
    };
    return HandleForeignAction;
})();
var canvasRef = "canvas";
var component = function (dictMonadEffect) {
    return function (dictMonadAsk) {
        return function (dictMonadAff) {
            var withContext$prime = Lunarbox_Foreign_Render.withContext(dictMonadAff.MonadEffect0())(canvasRef);
            var render = Data_Function["const"](Halogen_HTML_Elements.canvas([ Halogen_HTML_Properties.ref(canvasRef), Lunarbox_Component_Utils.className("scene__canvas"), Halogen_HTML_Events.onMouseMove((function () {
                var $22 = HandleEvent.create(Lunarbox_Foreign_Render.handleMouseMove);
                return function ($23) {
                    return Data_Maybe.Just.create($22($23));
                };
            })()), Halogen_HTML_Events.onMouseUp((function () {
                var $24 = HandleEvent.create(Lunarbox_Foreign_Render.handleMouseUp);
                return function ($25) {
                    return Data_Maybe.Just.create($24($25));
                };
            })()), Halogen_HTML_Events.onMouseDown((function () {
                var $26 = HandleEvent.create(Lunarbox_Foreign_Render.handleMouseDown);
                return function ($27) {
                    return Data_Maybe.Just.create($26($27));
                };
            })()), Halogen_HTML_Events.onDoubleClick((function () {
                var $28 = HandleEvent.create(Lunarbox_Foreign_Render.handleDoubleClick);
                return function ($29) {
                    return Data_Maybe.Just.create($28($29));
                };
            })()) ]));
            var handleAction = function (v) {
                if (v instanceof Init) {
                    return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(withContext$prime(Data_Function["const"](Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Unit.unit))))(function () {
                        return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadAff.MonadEffect0()))(Web_HTML.window))(function (window) {
                            return Data_Functor["void"](Halogen_Query_HalogenM.functorHalogenM)(Halogen_Query_HalogenM.subscribe(Halogen_Query_EventSource.eventListenerEventSource(dictMonadAff)("resize")(Web_HTML_Window.toEventTarget(window))(Data_Function["const"](new Data_Maybe.Just(ResizeCanvas.value)))));
                        });
                    });
                };
                if (v instanceof Render) {
                    return withContext$prime(function (ctx) {
                        return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.gets(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                            return v1.geometryCache;
                        }))(function (cache) {
                            return Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadAff.MonadEffect0()))(Lunarbox_Foreign_Render.renderScene(ctx)(cache));
                        });
                    });
                };
                if (v instanceof ResizeCanvas) {
                    return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(withContext$prime((function () {
                        var $30 = Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadAff.MonadEffect0()));
                        return function ($31) {
                            return $30(Lunarbox_Foreign_Render.resizeContext($31));
                        };
                    })()))(function () {
                        return handleAction(Render.value);
                    });
                };
                if (v instanceof HandleEvent) {
                    return withContext$prime(function (ctx) {
                        return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.gets(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                            return v1.geometryCache;
                        }))(function (cache) {
                            return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadAff.MonadEffect0()))(v.value0(ctx)(v.value1)(cache)))(function (action) {
                                return handleAction(new HandleForeignAction(action));
                            });
                        });
                    });
                };
                if (v instanceof HandleForeignAction) {
                    if (v.value0 instanceof Lunarbox_Foreign_Render.NoAction) {
                        return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Unit.unit);
                    };
                    return Halogen_Query_HalogenM.raise(new BubbleForeignAction(v.value0));
                };
                throw new Error("Failed pattern match at Lunarbox.Component.Editor.Scene (line 75, column 18 - line 99, column 46): " + [ v.constructor.name ]);
            };
            var handleQuery = function (v) {
                if (v instanceof LoadScene) {
                    return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                        var $15 = {};
                        for (var $16 in v1) {
                            if ({}.hasOwnProperty.call(v1, $16)) {
                                $15[$16] = v1[$16];
                            };
                        };
                        $15.geometryCache = v.value0;
                        return $15;
                    }))(function () {
                        return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(handleAction(Render.value))(function () {
                            return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(new Data_Maybe.Just(v.value1));
                        });
                    });
                };
                if (v instanceof Rerender) {
                    return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(handleAction(Render.value))(function () {
                        return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(new Data_Maybe.Just(v.value0));
                    });
                };
                if (v instanceof HandleResize) {
                    return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(handleAction(ResizeCanvas.value))(function () {
                        return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(new Data_Maybe.Just(v.value0));
                    });
                };
                throw new Error("Failed pattern match at Lunarbox.Component.Editor.Scene (line 102, column 17 - line 112, column 20): " + [ v.constructor.name ]);
            };
            return Halogen_Component.mkComponent({
                initialState: Data_Function["const"]({
                    context: Data_Maybe.Nothing.value,
                    geometryCache: Effect_Unsafe.unsafePerformEffect(Lunarbox_Foreign_Render.emptyGeometryCache)
                }),
                render: render,
                "eval": Halogen_Component.mkEval({
                    handleAction: handleAction,
                    handleQuery: handleQuery,
                    receive: Halogen_Component.defaultEval.receive,
                    initialize: new Data_Maybe.Just(Init.value),
                    finalize: Halogen_Component.defaultEval.finalize
                })
            });
        };
    };
};
module.exports = {
    LoadScene: LoadScene,
    HandleResize: HandleResize,
    Rerender: Rerender,
    BubbleForeignAction: BubbleForeignAction,
    component: component
};
